import React, { useState } from 'react';
import api from '../services/api';

const StatementsUpload = ({ onUploadSuccess }) => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [statementType, setStatementType] = useState('Сбербанк');

    const STATEMENT_TYPES = ['Сбербанк', 'ФКР ВТБ', 'ФКР прямые'];

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setMessage('');
        setResult(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            setMessage('Пожалуйста, выберите файл');
            return;
        }

        setLoading(true);
        setMessage('');
        setResult(null);

        const formData = new FormData();
        formData.append('file', file);
        formData.append('typedest', statementType);

        try {
            const response = await api.uploadStatements(formData);
            
            if (response.data) {
                setResult(response.data);
                if (response.data.success > 0) {
                    setMessage(`Успешно обработано: ${response.data.success} записей`);
                }
                if (response.data.errors > 0) {
                    setMessage(prev => prev + `, Ошибок: ${response.data.errors}`);
                }
            } else {
                setMessage(response.message || 'Файл успешно загружен');
            }

            // Обновляем счётчики после окончания загрузки выписок
            if (onUploadSuccess) {
                onUploadSuccess();
            }
        } catch (error) {
            setMessage('Ошибка загрузки файла');
            console.error('Upload error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page">
            <h2>Загрузка выписок из Excel</h2>
            <p>Загрузите Excel файл с данными банковских выписок</p>
            
            <div className="upload-container">
                <form onSubmit={handleSubmit} className="upload-form">
                    <div className="form-group">
                        <label htmlFor="statementType">Укажите тип выписок:</label>
                        <select
                            id="statementType"
                            value={statementType}
                            onChange={(e) => setStatementType(e.target.value)}
                        >
                            {STATEMENT_TYPES.map((type) => (
                                <option key={type} value={type}>{type}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="file">Выберите Excel файл:</label>
                        <input
                            type="file"
                            id="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        disabled={loading || !file}
                        className="upload-btn"
                    >
                        {loading ? 'Загрузка...' : 'Загрузить'}
                    </button>
                </form>

                {message && (
                    <div className={`message ${message.includes('Ошибка') ? 'error' : 'success'}`}>
                        {message}
                    </div>
                )}

                {result && (
                    <div className="upload-result">
                        <h4>Результаты обработки:</h4>
                        <div className="result-stats">
                            <div className="stat success">
                                <strong>Успешно:</strong> {result.success}
                            </div>
                            <div className="stat error">
                                <strong>Ошибок:</strong> {result.errors}
                            </div>
                        </div>

                        {result.warnings && result.warnings.length > 0 && (
                            <div className="warnings-section">
                                <h5>Предупреждения и ошибки:</h5>
                                <div className="warnings-list">
                                    {result.warnings.map((warning, index) => (
                                        <div key={index} className="warning-item">
                                            {warning}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className="upload-info">
                    <h4>Формат файла для выписок:</h4>
                    <ul>
                        <li>Данные начинаются с 2-й строки</li>
                        <li>Столбец A (1) - Дата выписки</li>
                        <li>Столбец B (2) - Номер</li>
                        <li>Столбец C (3) - Вид операции</li>
                        <li>Столбец D (4) - Контрагент</li>
                        <li>Столбец E (5) - ИНН контрагента</li>
                        <li>Столбец F (6) - БИК банка контрагента</li>
                        <li>Столбец G (7) - Счет контрагента</li>
                        <li>Столбец H (8) - Дебет, RUR</li>
                        <li>Столбец I (9) - Кредит, RUR</li>
                        <li>Столбец J (10) - Назначение</li>
                        <li>Столбец K (11) - Примечание</li>
                    </ul>
                    
                    <div className="upload-note">
                        <strong>Примечание:</strong> Файл должен соответствовать указанному формату.
                        При загрузке система автоматически свяжет выписки с соответствующими приказами по номеру дела.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StatementsUpload;